// 📂 components/Client/Table/Roles/ModuleRolesTableHeader.tsx
import React, { useEffect } from "react";
import { useRole } from "../../../../hooks/useRole";

const ModuleRolesTableHeader: React.FC = () => {
  const { dropdownOptions, fetchRolesDropdown } = useRole();

  useEffect(() => {
    if (dropdownOptions.length === 0) {
      fetchRolesDropdown();
    }
  }, []);

  if (dropdownOptions.length === 0) {
    return (
      <div className="px-4 py-3 text-center text-sm text-body dark:text-bodydark2">
        Cargando roles...
      </div>
    );
  }

  return (
    <div
      className="grid border-b border-stroke bg-gray-2 dark:border-strokedark dark:bg-boxdark-2"
      style={{
        gridTemplateColumns: `repeat(${dropdownOptions.length}, 132px)`,
      }}
    >
      {dropdownOptions.map((role) => (
        <div
          key={role.id}
          className="flex items-center justify-center px-2 py-3 text-center text-xs font-semibold leading-tight text-black dark:text-white"
        >
          {role.name}
        </div>
      ))}
    </div>
  );
};

export default ModuleRolesTableHeader;
